module.exports = __webpack_public_path__ + "img/dashcard.c03b3df3.svg";